/*
 *
 * OrganizationPage reducer
 *
 */

import { fromJS } from "immutable"
import {
  TOGGLE_CREATE_MODAL,
  GET_MEDITIONS_ORGANIZATION,
  GET_MEDITIONS_ORGANIZATION_WATCHER,
  GET_VISMA_PEOPLE_STATUS_WATCHER,
  GET_VISMA_PEOPLE_STATUS_SUCCESS,
  GET_VISMA_PEOPLE_STATUS_FAILED,
} from "./constants"

export const initialState = fromJS({
  createModal: false,
  meditions: [],
  meditionsOfficialized: [],
  vismaPeopleStatus: {},
  isLoadingVismaPeopleStatus: false
})

function organizationPageReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_CREATE_MODAL:
      return state.set("createModal", action.payload)

    case GET_MEDITIONS_ORGANIZATION_WATCHER:
      return state.set("meditions", []).set("meditionsOfficialized", [])
    case GET_VISMA_PEOPLE_STATUS_WATCHER:
      return state.set("isLoadingVismaPeopleStatus", true)
    case GET_VISMA_PEOPLE_STATUS_SUCCESS:
      return state.set('vismaPeopleStatus', action.payload).set("isLoadingVismaPeopleStatus", false)
    case GET_VISMA_PEOPLE_STATUS_FAILED:
      return state.set('vismaPeopleStatus', {}).set("isLoadingVismaPeopleStatus", false)

    case GET_MEDITIONS_ORGANIZATION:
      return state.set("meditions", action.payload.filter(
        (x) => x.status === "Finalizada" && x.officialized === 0
      )).set("meditionsOfficialized", action.payload.filter(
        (x) => x.status === "Cerrada" && x.officialized === 1
      ))
    default:
      return state
  }
}

export default organizationPageReducer
